import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";

const pdf = (path) => encodeURI(path);

const INVESTOR_CONTACT_PDF = "/assets/pdf/Investor_Contact.pdf";

const rows = [
  {
    id: "1",
    description: "Details of business",
    link: "/OurServices",
  },
  {
    id: "2",
    description: "MOA",
    link: "/MaterialDocuments",
  },
  {
    id: "3",
    description: "AOA",
    link: "/MaterialDocuments",
  },
  {
    id: "4",
    description: "Brief profile of the board of directors",
    link: "/share-governance-investor-services",
  },
  {
    id: "5",
    description: "Terms and conditions of appointment of independent directors",
    link: pdf(
      "/assets/pdf/Corporate_Policies/TERMS AND CONDITIONS FOR APPOINTMENT OF INDEPENDENT DIRECTORS.pdf"
    ),
  },
  {
    id: "6",
    description: "Composition of various committees of board of directors",
    link: "/share-governance-investor-services",
  },
  {
    id: "7",
    description:
      "Code of conduct of board of directors and senior management personnel",
    link: pdf(
      "/assets/pdf/Corporate_Policies/7.Code of Conduct - Policy- Final.pdf"
    ),
  },
  {
    id: "8",
    description:
      "Details of establishment of vigil mechanism/ Whistle Blower policy",
    link: pdf(
      "/assets/pdf/Corporate_Policies/Whistle Blower Policy- Final.pdf"
    ),
  },
  {
    id: "9",
    description:
      "Criteria of making payments to non-executive directors, if the same has not been disclosed in annual report",
    link: pdf(
      "/assets/pdf/Corporate_Policies/Criteria for making payments to the NED.pdf"
    ),
  },
  {
    id: "10",
    description: "Policy on dealing with related party transactions",
    link: pdf(
      "/assets/pdf/Corporate_Policies/6.Policy on Dealing with Related Party Transactions- Final.pdf"
    ),
  },
  {
    id: "12",
    description:
      "Details of familiarization programmes imparted to independent directors",
    link: pdf(
      "/assets/pdf/Corporate_Policies/14.Familiarisation_Programme- Final.pdf"
    ),
  },
  {
    id: "13",
    description: "Investor contact",
    link: INVESTOR_CONTACT_PDF,
  },
  {
    id: "14",
    description: "Financial information",
    link: "/FinancialAndReports",
  },
  {
    id: "15",
    description: "Shareholding pattern",
    link: "/shareholder-pattern",
  },
  {
    id: "16",
    description:
      "New name and the old name of the listed entity for a continuous period of one year, from the date of the last name change",
    link: "/MaterialDocuments",
  },
  {
    id: "17",
    description:
      "The policy for determination of materiality of events or information",
    link: pdf(
      "/assets/pdf/Corporate_Policies/Policy_on_Materiality events.pdf"
    ),
  },
];

const Regulation46 = () => {
  return (
    <>
      <Helmet>
        <title>Regulation 46 of LODR</title>
      </Helmet>

      <div className="main-content">
        <Header />

        <div
          className="relative h-[30vh] sm:h-[40vh] md:h-[50vh] w-full bg-no-repeat bg-cover bg-center mb-3"
          style={{
            backgroundImage: `url(/assets/img/Financial_banner.png)`,
          }}
        >
          <div className="absolute left-4 sm:left-8 md:left-12 top-1/2 transform -translate-y-1/2 text-xl sm:text-3xl md:text-4xl lg:text-5xl font-normal text-white px-4 sm:px-8 md:px-20 font-serif">
            Regulation 46 of LODR
          </div>
        </div>

        <h2 className="text-center text-lg sm:text-2xl font-semibold text-[#F26624] mb-4 px-4">
          REGULATION 46 OF THE SEBI (LODR)
        </h2>

        <div className="w-[94%] md:w-[80%] lg:w-[70%] mx-auto border border-gray-300 mb-10 overflow-x-auto">
          <div className="bg-[#F26624] text-white text-sm font-medium py-2 px-1">
            <div className="flex">
              <div className="w-16 text-center border-r border-white/40">
                S.No
              </div>
              <div className="flex-1 text-center border-r border-white/40">
                Particulars
              </div>
              <div className="w-28 text-center">Link</div>
            </div>
          </div>

          {rows.map((row) => (
            <div
              key={row.id}
              className="bg-white border-b border-gray-300 text-xs hover:bg-gray-50"
            >
              <div className="flex">
                <div className="w-16 text-center border-r border-gray-300 py-2">
                  {row.id}
                </div>
                <div className="flex-1 px-3 py-2 border-r border-gray-300">
                  {row.description}
                </div>
                <div className="w-28 flex items-center justify-center">
                  <a
                    href={row.link}
                    target="_blank"
                    rel="noreferrer"
                    className="text-[#F26624] hover:text-red-800 hover:underline text-sm font-semibold"
                  >
                    Click Here
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        <Footer />
      </div>
    </>
  );
};

export default Regulation46;
